if (!customElements.get('product-gallery-nav')) {
  customElements.define(
    'product-gallery-nav',
    class ProductGalleryNav extends HTMLElement {
      connectedCallback() {
        this.gallery = this.closest('media-gallery');
        if (!this.gallery) return;

        this.viewer = this.gallery.querySelector('[id^="GalleryViewer"]');
        if (!this.viewer) return;

        this.items = Array.from(this.viewer.querySelectorAll('.product__media-item[data-media-id]'));
        if (this.items.length < 2) return;

        this.dotsContainer = this.querySelector('[data-gallery-dots]');
        this.prevButton = this.gallery.querySelector('[data-gallery-prev]');
        this.nextButton = this.gallery.querySelector('[data-gallery-next]');

        const activeIndex = this.items.findIndex((item) => item.classList.contains('is-active'));
        this.currentIndex = activeIndex > -1 ? activeIndex : 0;

        this.buildDots();
        this.bindEvents();
        this.update();
      }

      buildDots() {
        if (!this.dotsContainer) return;

        this.dotsContainer.innerHTML = '';

        this.items.forEach((item, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'product__gallery-dot';
          dot.setAttribute('aria-label', `${index + 1}`);
          dot.innerHTML = '<span class="dot"></span>';
          dot.addEventListener('click', () => this.goTo(index));
          this.dotsContainer.appendChild(dot);
        });

        this.dots = Array.from(this.dotsContainer.children);
      }

      bindEvents() {
        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => this.goTo(this.currentIndex + 1));
        }

        this.viewer.addEventListener('slideChanged', (event) => {
          const index = this.items.indexOf(event.detail.currentElement);
          if (index < 0) return;
          this.currentIndex = index;
          this.update();
        });

        const thumbnails = this.gallery.querySelector('[id^="GalleryThumbnails"]');
        if (!thumbnails) return;

        thumbnails.querySelectorAll('[data-target] button').forEach((button) => {
          button.addEventListener('click', () => {
            const target = button.closest('[data-target]').dataset.target;
            const index = this.items.findIndex((item) => item.dataset.mediaId === target);
            if (index < 0) return;
            this.currentIndex = index;
            this.update();
          });
        });
      }

      goTo(index) {
        const total = this.items.length;
        const nextIndex = (index + total) % total;

        this.currentIndex = nextIndex;
        this.gallery.setActiveMedia(this.items[nextIndex].dataset.mediaId, false);
        this.update();
      }

      update() {
        if (!this.dots) return;
        this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === this.currentIndex));
      }
    }
  );
}